import { makeStyles } from '@mui/styles'
const useStyleMenu = makeStyles(() => ({
  box: {
    height: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'none',
    boxShadow: '2px 0px 4px rgba(36, 55, 143, 0.2)',
    '@media all and (min-width: 900px)': {
      display: 'flex'
    }
  },
  dividerStyle: {
    backgroundColor: '#D0D1D3',
    height: 2
  },
  listItemSize: {
    height: 30
  },
  avatarStyle: {
    backgroundColor: '#00a78f',
    color: '#FFFFFF'
  },
  arrowRight: {
    position: 'absolute',
    right: 4,
    opacity: 0
  },
  bottomDividirStyle: {
    backgroundColor: '#EAEAEA',
    height: 2
  },
  avatarCircle: {
    background: '#00a78f',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    color: '#fff',
    fontFamily: 'Raleway'
  }
}))

export default useStyleMenu
